import { Injectable } from '@angular/core';
import { SessionService } from 'src/core/session/domain/session.service';
import { MasterDataService } from 'src/core/master-data/domain/master-data-service';
import { FiltersService } from 'src/core/filters/domain/filters-service';
import { QueueService } from 'src/core/queue/domain/queue.service';
import { TaskService } from 'src/core/tasks/domain/task.service';
import { ApiService } from 'src/core/api/domain/api.service';
import { SystemService } from 'src/core/system/system.service';
import { DescriptionFileCacheService } from 'src/core/description-file-cache/domain/description-file-cache.service';
import { DeviceService } from 'src/core/device/device.service';
import { NotificationsService } from 'src/core/notifications/domain/notifications.service';

@Injectable({
  providedIn: 'any',
})
export class Logout {
  constructor(
    private readonly apiService: ApiService,
    private readonly filtersService: FiltersService,
    private readonly deviceService: DeviceService,
    private readonly masterData: MasterDataService,
    private readonly queueService: QueueService,
    private readonly session: SessionService,
    private readonly taskService: TaskService,
    private readonly systemService: SystemService,
    private readonly descriptionFileCacheService: DescriptionFileCacheService,
    private readonly notificationsService: NotificationsService
  ) {}

  async execute(): Promise<void> {
    await this.descriptionFileCacheService.clearAllCachedDescriptionFiles();
    await this.apiService.clear();
    await this.filtersService.clear();
    await this.queueService.clear();
    await this.session.clear();
    await this.taskService.clear();
    await this.systemService.clearSessionRelatedData();
    await this.masterData.clear();
    await this.deviceService.clear();
    await this.notificationsService.clear();
  }
}
